
import React from "react";

const TestimonialsSection = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            What Our <span className="text-[#8932c8]">Customers</span> Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
            <p className="text-gray-600 italic mb-4">
              "Spharaka XDR has transformed our security operations. The AI powered detection and automated response capabilities have significantly reduced our workload and improved our overall security posture."
            </p>
            <p className="text-sm font-semibold">
              Akash David, CISO
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
            <p className="text-gray-600 italic mb-4">
              "We were struggling to keep up with the increasing volume of alerts and the complexity of modern threats. Spharaka XDR has been a game-changer, providing us with the visibility and automation we need to stay ahead of attackers."
            </p>
            <p className="text-sm font-semibold">
              Abijith Malik, Head of IT
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
